import { useEffect, useState } from 'react'

import styles from './BuildInfoBadge.module.scss'

const BUILD_NUMBER = import.meta.env.VITE_APP_RUN_NUMBER ?? ''

const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
}

export const BuildInfoBadge = () => {
  const [time, setTime] = useState(() => formatTime(new Date()))

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(formatTime(new Date()))
    }, 60_000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className={styles.badge}>
      <span className={styles.prefix}>v</span>
      <span className={styles.text}>
        {BUILD_NUMBER} {time}
      </span>
    </div>
  )
}
